
import LoadingSpinner from './LoadingSpinner.vue'
import Entry from './Entry.vue'
import { loadEntries } from '../../EntryApi'
import SpinnerIco from '../SpinnerIco.vue'

export default {
	name: 'EntryList',
	components: { LoadingSpinner, Entry, SpinnerIco },
	inject: [ 'endpoint' ],
	props: {
		locale: String,
		filter: Object,
		selectable: Boolean,
		mode: { type: String, default: 'all' },
		value: Array,
		allowedContentTypes: Array,
	},
	data: () => ({
		loading: 0,
		entries: [],
		loadingTimeout: null,
		currentFilter: {
			contentType: null,
			search: '',
		},
		selectedIds: [],
		selectionCache: {},
		message: '',
		limit: 20,
		skip: 0,
		total: 20,
		uniqueId: Math.random().toString(36).substring(2),
	}),
	computed: {
		matchedEntries() {
			return this.entries.filter(entry => entry.match)
		},
	},
	watch: {
		filter: {
			deep: true,
			handler() {
				this.skip = 0
				this.filterChanged(true)
			},
		},
	},
	mounted() {
		this.filterChanged(true)
	},
	methods: {
		async filterChanged(force = false) {
			if (force || this.filter.contentType != this.currentFilter.contentType) {
				await this.loadEntries()
				this.currentFilter.contentType = this.filter.contentType
			}
			/*for (const entry of this.entries) {
				entry.match = false
					|| this.filter.search == ''
					|| entry.search?.indexOf?.(this.filter.search.toLowerCase()) >= 0
					|| entry.sys.id.toLowerCase() == this.filter.search.toLowerCase()
			}*/
		},
		onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
			if (this.total > this.skip && scrollTop + clientHeight + 2 >= scrollHeight) {
				this.loadMore()
			}
		},
		async loadMore() {
			this.skip += this.limit
			if (this.loading) return
			// TODO: only do this when the last loading was successful
			this.loadEntries(true)
		},
		// TODO ARCH: where should the loading happen?
		//       here or somewhere else? a mixin?
		//       spaces/390osprlshgj/environments/staging
		async loadEntries(append = false) {
			if (this.loadingTimeout)
				clearTimeout(this.loadingTimeout)

			this.loadingTimeout = window.setTimeout(async () => {
				this.loading++
				this.loadingTimeout = null
				if (!append) this.entries = []

				try {
					if (this.allowedContentTypes?.length)
						this.filter.allowedContentTypes = this.allowedContentTypes

					const key = this.uniqueId

					const entries = await loadEntries(this.endpoint, this.filter, this.limit, this.skip, 0, key)
					this.total = entries.total

					if (append)
						this.entries.push(...entries.items)
					else
						this.entries = entries.items
				}
				catch (e) {
					// when we pass along a key, this mechanism cancels previous requests.
					// these cancellations cause an abortError.
					if (e?.name == 'AbortError') return
					throw e
				}
				finally {
					this.loading--
					this.loadingTimeout = null
				}
			}, 400)
		},
		clickEntry(entry) {
			if (this.selectable) {
				const s = this.selectedIds.indexOf(entry.sys.id)
				if (s >= 0)
					this.selectedIds.splice(s, 1)
				else
					this.selectedIds.push(entry.sys.id)
				const lookup = {}
				for (const entry of this.entries) lookup[entry.sys.id] = entry
				// in case the search changes, we remember the objects related to the selected ids
				this.selectedIds.forEach(id => {
					if (!lookup[id]) return
					this.selectionCache[id] = lookup[id]
				})
				this.$emit('input', this.selectedIds.map(id => this.selectionCache[id]))
			}
			else {
				this.$emit('input', [ entry ])
			}
		},
	},
}
